import { dev } from '$app/environment';
import { Capacitor } from "@capacitor/core";
import { init } from '@sentry/sveltekit';
import { handleErrorWithSentry } from "@sentry/sveltekit";
import { initializeMobile } from "./kernel/mobile.kernel";
import { initializeWeb } from "./kernel/web.kernel";

// -----------------------------------------------------------------
// Initialize the Sentry SDK
// -----------------------------------------------------------------

// if(!dev){
//   init({

//     // Per Env --> (Sentry: Campus Community - Stage, Campus Community - Prod)
//     dsn: 'https://4bf5daf075a7a354f9e94be27475a676@o4507765166899200.ingest.us.sentry.io/4507765168340992',
//     tracesSampleRate: 1.0,

//     // This sets the sample rate to be 10%. You may want this to be 100% while
//     // in development and sample at a lower rate in production
//     replaysSessionSampleRate: 0.1,

//     // If the entire session is not sampled, use the below sample rate to sample
//     // sessions when an error occurs.
//     replaysOnErrorSampleRate: 1.0,

//     integrations: [],
//   });
    // If you have a custom error handler, pass it to `handleErrorWithSentry`
    export const handleError = handleErrorWithSentry();
// }


// -----------------------------------------------------------------
// Initialize the "boot" sequence of the app based on the platform
// -----------------------------------------------------------------
if (Capacitor.isNativePlatform()) {
  initializeMobile();
} else {
  initializeWeb();
}